<!-- //
组件-滚动表格
@auth xuyd
@date 2024-05-01
//-->
<template>
  <dv-scroll-board class="widget-view" :config="viewProps.dataConfig">
  </dv-scroll-board>
</template>

<script>
import ApiDesignApi from "@/api/datasvc/apiDesign.api";

export default {
  name: 'WidgetScrollTableView',
  components: {},
  data() {
    return {}
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    'widgetProps.datasourceProps': {
      handler: function (val) {
        this.handleFetchData().then(data => this.handleFillData(data)).then(()=>{});
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    },
    datasourceProps() {
      return this.widgetProps.datasourceProps;
    }
  },
  created() {
    this.handleFetchData().then(data => this.handleFillData(data)).then(()=>{});
  },
  methods: {
    /**
     * 获取数据
     */
    handleFetchData() {
      return new Promise((resolve, reject) => {
        if (this.datasourceProps.datasourceType === 'STATIC') {
          // [{},{}]
          let respData = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType].data;
          // console.log(`======${this.$route.name} STATIC respData====>`, respData);
          resolve(respData);
        } else if (this.datasourceProps.datasourceType === 'API') {
          let dataConfig = this.datasourceProps.dataConfig[this.datasourceProps.datasourceType];
          if (dataConfig && dataConfig.datasource) {
            let reqParams = (typeof dataConfig.reqParams === 'string') ? JSON.parse(dataConfig.reqParams) : dataConfig.reqParams;
            ApiDesignApi.runApi(dataConfig.datasource, reqParams).then(resp => {
              console.log(`======${this.$route.name} respData====>`, resp);
              resolve(resp.data);
            });
          } else {
            reject();
          }
        } else {
          reject();
        }
      });
    },

    /**
     * 填充数据 [{a: '1', b:21, c: 33},{a: '11', b:221, c: 133}]
     * @param respData
     */
    handleFillData(respData) {
      let dataList = (typeof respData === 'string') ? JSON.parse(respData) : respData;
      let headerList = [];
      let valueList = [];
      // 存在映射
      if(this.datasourceProps.dataMapping && this.datasourceProps.dataMapping.length > 0) {
        this.datasourceProps.dataMapping.forEach(item => {
          headerList.push(item.label);
        });
      }

      // 获取data
      dataList.forEach(rowData => {
        let dataArr = [];
        this.datasourceProps.dataMapping.forEach(item => {
          dataArr.push(rowData[item.field]);
        });
        valueList.push(dataArr);
      });
      let dataConfig = {...this.viewProps.dataConfig};
      dataConfig.header = headerList;
      dataConfig.data = valueList;
      this.viewProps.dataConfig = dataConfig;
    }
  }

}

</script>
<style lang="less" scoped>
.widget-view {
  width: 100%;
  height: 100%;
}
</style>
